import { HDAccessProvider, } from '@ocm_customer/account_pro-ui-access';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CustomerAccountNavigation } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React from 'react';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useExperienceContext } from '../../hooks/useContexts';
import { useInterceptors } from '../../hooks/use-interceptors';
import { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';
import { getWindow } from '../../utils/general';
import { BackToProjectLink } from '../order-details/BackToProjectLink/BackToProjectLink';
export var PageLayout = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, crumbs = _a.crumbs, customerRole = _a.customerRole, customerType = _a.customerType, headerComponent = _a.headerComponent, internalRoutes = _a.internalRoutes, isMobile = _a.isMobile, pageTitle = _a.pageTitle;
    var redirectError = useInterceptors().redirectError;
    var isLoggedIn = useThdCustomer().isLoggedIn;
    var _f = useExperienceContext(), configService = _f.configService, isConsumerApp = _f.isConsumerApp;
    var ENABLE_NEW_ADDRESS_PAGE = configService.ENABLE_NEW_ADDRESS_PAGE, ENABLE_NEW_PROGRAM_DETAILS_PAGE = configService.ENABLE_NEW_PROGRAM_DETAILS_PAGE, ENABLE_NEW_PROXTRA_PRICING_PAGE = configService.ENABLE_NEW_PROXTRA_PRICING_PAGE, ENABLE_NEW_PAYMENTS_PAGE = configService.ENABLE_NEW_PAYMENTS_PAGE, ENABLE_NEW_ADDMANAGE_USERS = configService.ENABLE_NEW_ADDMANAGE_USERS, ENABLE_NEW_PURCHASE_HISTORY_PAGE = configService.ENABLE_NEW_PURCHASE_HISTORY_PAGE, ENABLE_NEW_EMAIL_PREFERENCE_LINK = configService.ENABLE_NEW_EMAIL_PREFERENCE_LINK, ENABLE_NUCLEUS_QUOTE_EXPERIENCE = configService.ENABLE_NUCLEUS_QUOTE_EXPERIENCE;
    var features = {
        isAddressCustUserSwitchEnabled: true,
        isQBOnlineEnabled: true,
        isInstantCheckoutEnabled: true,
        isPOJobNamesEnabled: true,
        isAddUsersLinkEnabled: true,
        isWorkflowEnabled: true,
        isRunnerAllowanceEnabled: true,
        isKeyTagsEnabled: true,
        isDefaultAgreementCodeEnabled: true,
        isCitiSsoEnabled: true,
        ENABLE_NEW_ADDRESS_PAGE: ENABLE_NEW_ADDRESS_PAGE === '1',
        ENABLE_NEW_EMAIL_PREFERENCE_LINK: ENABLE_NEW_EMAIL_PREFERENCE_LINK === '1',
        ENABLE_NEW_PROGRAM_DETAILS_PAGE: ENABLE_NEW_PROGRAM_DETAILS_PAGE === '1',
        ENABLE_NEW_PROXTRA_PRICING_PAGE: ENABLE_NEW_PROXTRA_PRICING_PAGE === '1',
        ENABLE_NEW_PAYMENTS_PAGE: ENABLE_NEW_PAYMENTS_PAGE === '1',
        ENABLE_NEW_PURCHASE_HISTORY_PAGE: ENABLE_NEW_PURCHASE_HISTORY_PAGE === '1',
        ENABLE_NEW_ADDMANAGE_USERS: ENABLE_NEW_ADDMANAGE_USERS === '1',
        ENABLE_NUCLEUS_QUOTE_EXPERIENCE: ENABLE_NUCLEUS_QUOTE_EXPERIENCE === 'true',
    };
    var user = {
        role: (customerRole || '').toUpperCase(),
        type: (customerType || '').toUpperCase(),
        isMemberOfHierarchyOrg: !!((_e = (_d = (_c = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.THD_CUST_ACCOUNT_OM) === null || _c === void 0 ? void 0 : _c.userState) === null || _d === void 0 ? void 0 : _d.customer) === null || _e === void 0 ? void 0 : _e.hierarchyOrgId),
    };
    var values = {
        features: features,
        user: user,
    };
    var cancelGuestFlow = (internalRoutes === null || internalRoutes === void 0 ? void 0 : internalRoutes[0]) === '/myaccount/cancel-items' && !isLoggedIn;
    var columnSpanClass = '';
    if (!isConsumerApp && cancelGuestFlow) {
        columnSpanClass = 'lg:sui-col-span-12';
    }
    else if (!isConsumerApp) {
        columnSpanClass = 'lg:sui-col-span-9';
    }
    else {
        columnSpanClass = '';
    }
    return (React.createElement("div", { className: "grid isBound" }, redirectError ? (React.createElement(Alert, { status: "info", size: "large" }, redirectError.message)) : (React.createElement(HDAccessProvider, { values: values },
        React.createElement("div", { className: "sui-w-screen sui-px-[16px] sm:sui-px-8" },
            React.createElement("div", { className: "sui-flex sui-mb-8" },
                React.createElement("div", { className: "no-print sui-grid sui-gap-2 sui-pt-[10px]" },
                    !isConsumerApp && !cancelGuestFlow && (React.createElement(Breadcrumbs, { isMobile: isMobile !== null && isMobile !== void 0 ? isMobile : false, routes: crumbs })),
                    React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true }, pageTitle),
                    React.createElement(BackToProjectLink, null)),
                React.createElement("div", { className: "sui-hidden md:sui-block lg:sui-block sui-flex-grow", style: { paddingRight: 10 } }, headerComponent)),
            React.createElement("div", { className: "sui-grid sui-grid-cols-12 md:sui-gap-5 lg:sui-gap-5" },
                (internalRoutes === null || internalRoutes === void 0 ? void 0 : internalRoutes[0]) !== '/myaccount/guest-order-tracking' &&
                    !cancelGuestFlow && (React.createElement("div", { className: "".concat(isConsumerApp ? '' : 'sui-col-span-12 lg:sui-col-span-3') },
                    React.createElement(ErrorBoundary, { name: "customer-account-navigation" },
                        React.createElement(QueryProvider, { cacheKey: "customer-account-navigation" }, !isConsumerApp && React.createElement(CustomerAccountNavigation, null))))),
                React.createElement("div", { className: "sui-col-span-12 ".concat(columnSpanClass) },
                    React.createElement(ErrorBoundary, { name: (internalRoutes === null || internalRoutes === void 0 ? void 0 : internalRoutes[0]) || 'page content' }, children))))))));
};
export default PageLayout;
